import owd from 'owd/owd';
import '../lib/dropkick';

export default class Select extends owd.Component {
	init() {
        this.$element.dropkick({
			mobile: true
		});

		this.name = this.$element.attr('data-select');

		this.$resetters = $('[data-select-resetter="' + this.name + '"]');

		this.bind();
	}

	bind() {
		this.on('click', this.$resetters, () => {
			this.$element.dropkick('reset');
		})
	}

	destroy() {
		super.destroy();
	}
}

owd.registerComponent('select', {
	component: Select
});
